import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
        loading: false
};

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.EDIT_MEDIAFILE_START: 
            return updateObject(state, { loading: true });
        case actionTypes.EDIT_MEDIAFILE_FAIL: 
            return updateObject(state, { loading: false });
        case actionTypes.EDIT_MEDIAFILE_SUCCESS: 
            return updateObject(state, { loading: false });
        default: 
            return state;
    }
}

export default reducer;
